import React from 'react';
import './Users.css';
import './UsersMobile.css';
import { UsersLogic } from './UsersLogic';
import { FcGoogle } from "react-icons/fc";
import { GoLaw } from 'react-icons/go';
// import email from '../../../public/email.png'

const UsersMobileUI = () => {
    const { users, accessLevelList, handleConfirmUser, handleApproveUser, handleToggleEmployeeActive, handleAccessLevelChange
    } = UsersLogic()

    return (
        <div>

            <div className='user-mobile-header'>
                <h5 className='user-mobile-header-text'>Users</h5>
            </div>


            <div className='table-content-user-mb'>

                {users.map((user) => {
                    const getAttr = (name) => user.Attributes.find(attr => attr.Name === name)?.Value;
                    const empInfoStr = getAttr('custom:empInfo');

                    let accessLevel = '';
                    let isEmployeeApproved = false;
                    let isEmployeeActive = false;

                    try {
                        const empInfo = empInfoStr ? JSON.parse(empInfoStr) : {};
                        accessLevel = empInfo.accessLevel?.toString() || '1';
                        isEmployeeApproved = empInfo.isEmployeeApproved;
                        isEmployeeActive = empInfo.isEmployeeActive;
                    } catch (err) {
                        console.error('Invalid empInfo JSON:', err);
                    }

                    return (
                        <div key={user.Username} className='individual-div'>
                            <div className="align-middle user-email-mb">
                                {user.UserStatus === "EXTERNAL_PROVIDER" && (
                                    <span style={{ marginRight: '6px', fontSize: "16px" }}>
                                        <FcGoogle />
                                    </span>
                                )}
                                {(
                                    <div >
                                        {accessLevel === '1' && (
                                            <span style={{ marginRight: '6px', color: "var(--buttonColor)", fontSize: "20px" }}>
                                                <GoLaw />
                                            </span>
                                        )}
                                    </div>
                                )}


                                {getAttr('email')}
                            </div>

                            <div className="d-flex justify-content-between align-items-center flex-wrap action-container mt-2">
                                <div>
                                    <span className='text-muted-mb'>Status : </span>
                                    {user.UserStatus === 'UNCONFIRMED' ? (
                                        <button
                                            className="btn-primary-1 user-action-btn-mb"
                                            onClick={() => handleConfirmUser(user.Username)}
                                        >
                                            Confirmed User
                                        </button>
                                    ) : !isEmployeeApproved ? (
                                        <button
                                            className="btn-primary-1 user-action-btn-mb"
                                            onClick={() => handleApproveUser(user.Username)}
                                        >
                                            Approve User
                                        </button>
                                    ) : isEmployeeActive ? (
                                        <button
                                            className="btn-danger-1 user-action-btn-mb"
                                            onClick={() => handleToggleEmployeeActive(user.Username, false)}
                                        >
                                            Disable User
                                        </button>
                                    ) : (
                                        <button
                                            className="btn-info-1 user-action-btn-mb"
                                            onClick={() => handleToggleEmployeeActive(user.Username, true)}
                                        >
                                            Activate User
                                        </button>
                                    )}
                                </div>

                                <div>
                                    <select
                                        value={accessLevel}
                                        onChange={(e) => handleAccessLevelChange(user.Username, e.target.value)}
                                        className="form-select user-select-mb"
                                    >
                                        <option value="0" hidden>Select</option>
                                        {accessLevelList.map((level) => (
                                            <option key={level.value} value={level.value}>
                                                {level.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>


                        </div>
                    );
                })}

            </div>



        </div>
    );
};

export default UsersMobileUI;
